import { privateAxios } from "@/common/api/axios";
import { LogRequest, LogRequestResponse } from "@/common/types/logs/request.type";

import { UseQueryResult, useQuery } from "@tanstack/react-query";

type UseLogRequestOptions = {
  enabled?: boolean;
};

type UseLogRequestType = (id?: string, options?: UseLogRequestOptions) => UseQueryResult<LogRequest, unknown>;

const useLogRequest: UseLogRequestType = (id?: string, options = {}) => {
  const { enabled = true } = options;

  return useQuery<LogRequestResponse, unknown, LogRequest>({
    enabled: Boolean(id) && enabled,
    queryKey: ['logRequests', id],
    queryFn: () => {
      return privateAxios.get(`/log/requests/${id}`);
    },
    select: (data) => data?.data?.data,
  });
};

export default useLogRequest;
